import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, withRouter } from 'react-router-dom'
import UrlPattern from 'url-pattern'
import { useAuth0 } from 'shared/utils/auth0'
import { determineAuthScreen } from 'shared/utils/auth0/helper'

const urlPattern = new UrlPattern(`${process.env.CHAT_PUBLIC_PATH}/:initialType(/*)`)

const PrivateRoute = ({ component: Component, path, location, ...rest }) => {
  //url pattern params retrieving
  const historyParams = urlPattern.match(window.location.pathname)
  //auth0 hook
  const { isAuthenticated, login } = useAuth0()

  useEffect(() => {
    if (!isAuthenticated) {
      const loginOptions = {
        initialScreen: determineAuthScreen(historyParams?.initialType)
      }

      login(loginOptions)
    }
  }, [isAuthenticated, login, path, location])

  const render = props =>
    isAuthenticated === true && <Component {...props} />

  return <Route path={path} render={render} {...rest} />
}

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  path: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired
}

export default withRouter(PrivateRoute)
